<script>import { onMount, tick } from "svelte";
import { tooltipAction } from "../../actions";
import { attrValue } from "../../utils/html";
import {} from "lottie-web";
import { afterNavigate } from "$app/navigation";
export let name;
export let size = "default";
export let classNames = "";
export let tooltip = {};
export let animationOnHover = true;
export let animationOnLoad = true;
export let triggerMorph = false;
export let isMorphAnimationComplete = false;
export let isAnimationComplete = false;
export let speed = 1;
export let speedMorph = 1;
export let keepOriginalColor = false;
export let loading = "lazy";
export let parentRef = null;
$: lottieSrc = `/lottie/${name}.json`;
let targetElement;
let lottieRef;
const playAnimation = (state) => {
  if (lottieRef?.playerInstance) {
    lottieRef.playerInstance.state = state;
    lottieRef.playerInstance.playFromBeginning();
  }
};
const playAnimationLoad = (state) => {
  if (lottieRef?.playerInstance) {
    if (speed) lottieRef.playerInstance.speed = speed;
    playAnimation(state);
  }
};
const playAnimationMorph = (state) => {
  if (lottieRef?.playerInstance) {
    if (speed) lottieRef.playerInstance.speed = speedMorph;
    playAnimation(state);
  }
};
const initLottie = async () => {
  if (lottieRef || parentRef) {
    await tick();
    targetElement = parentRef instanceof HTMLElement ? parentRef : lottieRef;
    lottieRef?.addEventListener("ready", () => {
      if (animationOnLoad) {
        playAnimationLoad(`in-${name}`);
      } else {
        lottieRef?.playerInstance?.goToLastFrame();
      }
    });
    targetElement?.addEventListener("mouseenter", () => {
      if (animationOnHover && !lottieRef?.playerInstance?.isPlaying) {
        playAnimationLoad(`hover-${name}`);
        lottieRef?.playerInstance?.addEventListener("complete", () => {
          lottieRef?.playerInstance?.goToLastFrame();
        });
      }
    });
  }
};
onMount(async () => {
  const { defineElement } = await import("@lordicon/element");
  const { loadAnimation } = await import("lottie-web");
  defineElement(loadAnimation);
  await initLottie();
});
afterNavigate(async () => {
  await initLottie();
});
$: if (triggerMorph) {
  lottieRef?.playerInstance?.addEventListener("complete", () => {
    isMorphAnimationComplete = true;
  });
  playAnimationMorph(`morph-${name}`);
} else if (lottieRef) {
  isAnimationComplete = true;
}
</script>

<div
	class={attrValue([`relative flex-shrink-0`, classNames, size])}
	role="img"
	aria-label={name}
	use:tooltipAction={tooltip}
>
	<lord-icon
		{loading}
		class={attrValue([`${keepOriginalColor ? '' : 'current-color'}`, 'w-full h-full'])}
		bind:this={lottieRef}
		src={lottieSrc}
	/>
</div>

<style>.tiny{height:.5rem;width:.5rem}.small{height:1rem;width:1rem}.default:not(.w-full){height:1.5rem;width:1.5rem}.big{height:2rem;width:2rem}.huge{height:3rem;width:3rem}</style>
